import { get } from 'lodash'
import { required, requiredCheck } from '../../../../utils/validation'

export default values => {
  const qualifications = requiredCheck(
    get(values, 'universityDegree')
    || get(values, 'tafeQualification')
    || get(values, 'apprenticeship')
    || get(values, 'experience')
    || get(values, 'membership')
    || get(values, 'nonAccreditedTraining')
    || get(values, 'organisational')
    || get(values, 'peakBody')
  )

  return {
    membership: qualifications,
    relevantExperience: required(get(values, 'relevantExperience')),
  }
}
